import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { HotlineProDetailNegotiatePage } from '@/feature/hotline/professional/detail/negotiate/page/HotlineProDetailNegotiatePage';
import { hotlineProAuthOptions } from '@/feature/hotline/professional/util/canUseHotlineUser';
import { useAuthentication } from '@/hooks/auth/useAuthentication';
/**
 * 匿名ホットライン コンサル詳細 チャットページ
 * @description api データ取得を伴わないアクセス制限等を行う
 */
export const HotlineProDetailNegotiate = () => {
    // 認証周りの判定取得
    const { message: authRedirectMessage, redirectTo: authRedirectTo } = useAuthentication(hotlineProAuthOptions);
    // リダイレクト: ユーザー認証
    if (authRedirectTo) {
        return _jsx(CustomRedirect, { message: authRedirectMessage, to: authRedirectTo });
    }
    return _jsx(HotlineProDetailNegotiatePage, {});
};
